import portrait from "../../assets/images/personal/portrait3.png";
import "./HeroSection.css";

function HeroSection() {
  return (
    <section className="hero-section">
      <img
        src={portrait}
        className="hero-section__portrait"
        alt="portrait"
        width={180}
        height={180}
      />
      <div className="hero-section__text">
        <h1>Lars Hamburger</h1>
        <p>Full Stack Developer</p>
      </div>
    </section>
  );
}

export default HeroSection;
